import React from 'react';

const borderRadius = '2.5rem';
const innerBorderRadius = '2rem';

const Board = ({
  className = '', fillScreen = false, style = {}, children,
}) => (
  <div
    className={(`position-relative ${className}`).trim()}
    style={{
      borderRadius,
      boxShadow: '0 .6rem rgba(88, 18, 155, .5)',
    }}
  >
    <div
      className="img-bg"
      style={{
        backgroundImage: 'url("/assets/img/board-pattern.jpg")',
        borderRadius,
        boxShadow: 'inset -1px -.25rem 0 1px rgba(113, 45, 0, .7)',
      }}
    />
    <div
      className="position-absolute w-100 h-100 d-flex"
      style={{ padding: '1rem 1rem 1.5rem' }}
    >
      <div
        className="position-relative flex-fill"
        style={{
          background: 'linear-gradient(#FEFAE0, #DFF1F8)',
          borderRadius: innerBorderRadius,
          boxShadow: 'inset 1px .5rem 0 1px #FDC1DA',
        }}
      >
        <div
          className="position-relative h-100"
          style={{
            borderRadius: innerBorderRadius,
            boxShadow: 'inset 1px .25rem 0 1px #9F4001',
          }}
        />
      </div>
    </div>
    <div className="board-content">
      <div className={fillScreen ? 'fill-screen' : ''} style={style}>
        {children}
      </div>
    </div>
  </div>
);

export default Board;
